import { render, staticRenderFns } from "./DetailListCard.vue?vue&type=template&id=7fc6843e&scoped=true"
import script from "./DetailListCard.vue?vue&type=script&lang=js"
export * from "./DetailListCard.vue?vue&type=script&lang=js"
import style0 from "./DetailListCard.vue?vue&type=style&index=0&id=7fc6843e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc6843e",
  null
  
)

export default component.exports